import 'intl-pluralrules';
import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
// import Backend from "i18next-http-backend";
// import LanguageDetector from "i18next-browser-languagedetector";
import fa from './fa.json';
import en from './en.json';
import ar from './ar.json';
import ur from './ur.json';
import tr from './tr.json';
//
const resources = {
	fa: {
		translation: fa
	},
	en: {
		translation: en
	},
	ar: {
		translation: ar
	},
	ur: {
		translation: ur
	},
	tr: {
		translation: tr
	}
};
i18n
	.use(initReactI18next)
	// .use(LanguageDetector)
	// .use(Backend)
	.init({
		resources,
		lng: localStorage.getItem('lang') ?? 'fa',
		debug: false,
		fallbackLng: 'fa',
		// ns: ['translation'],
		// defaultNS: 'translation',
		nsSeparator: '.',
		// keySeparator: false,
		pluralSeparator: '_',
		contextSeparator: '_',
		react: {
			useSuspense: true
		},
		interpolation: {
			escapeValue: false // react already safes from xss
		},
		// ignoreJSONStructure: true,
		// initImmediate: false,
		compatibilityJSON: 'v4'
	});

export default i18n;
